import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loading, ErrorBox } from "@/components/common";

export const DeletionRequests = () => {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");
  const load = () => api.get("/platform/deletion-requests").then((r) => setRows(r.data)).catch((e) => setError(errMessage(e)));
  useEffect(() => { load(); }, []);
  const process = async (u) => {
    if (!window.confirm(`Anonymiser le compte de ${u.name} ? Ses Take 5 et inspections sont conservés ; l'opération est définitive.`)) return;
    try {
      await api.post(`/platform/deletion-requests/${u.id}/process`);
      toast.success("Compte anonymisé.");
      load();
    } catch (e) { toast.error(errMessage(e)); }
  };
  if (error) return <ErrorBox message={error} onRetry={load} />;
  if (!rows) return <Loading />;
  if (!rows.length) return <p data-testid="deletion-requests-empty" className="text-sm text-muted-foreground">Aucune demande de suppression de compte.</p>;
  return (
    <div className="space-y-2" data-testid="deletion-requests">
      {rows.map((u) => (
        <div key={u.id} data-testid={`deletion-request-${u.id}`} className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border bg-card p-3">
          <div className="min-w-0">
            <p className="font-semibold">{u.name}</p>
            <p className="text-xs text-muted-foreground">{u.email} · {u.workplaces.join(", ") || "aucun workplace"} · demandé le {new Date(u.deletion_requested_at).toLocaleDateString("fr-FR")}</p>
          </div>
          <Button size="sm" variant="outline" data-testid={`deletion-process-${u.id}`} onClick={() => process(u)} className="border-red-500/60 text-red-500 hover:bg-red-500/10">Anonymiser le compte</Button>
        </div>
      ))}
    </div>
  );
};
